export * from './decimal-value.pipe';
